import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';
import { formatarTelefone, formatarCEP } from './../../utils.js'; 
import LogoDelivery from '../../assets/img/delivery.svg';
import { BrowserView, MobileView } from 'react-device-detect';
import { Container } from 'react-bootstrap';
import {
  Grid,
  Typography
} from "@mui/material";

export default function CardFilial(props) {

let _recebido = Object.values(props);
let _cidade = Object.values(_recebido)[1];
let _cidadeClicada = _cidade.map(a => a.cidade) + "-" + _cidade.map(a => a.uf);
let _telefone = Object.values(_recebido[0].map(a => a.telefone))[0];
let _horarios = Object.values(_recebido[1].map(a => a.saidas))[0];

let _horarioSemanal = (_horarios?.indexOf('e Sá') == -1 ? _horarios : _horarios?.substring(0, _horarios?.indexOf('e Sá') - 1 ));
let _horarioFinalSemana = (_horarios?.indexOf('Sá') == -1 ? '' : _horarios?.substring(_horarios?.indexOf('Sá')) );

  return (
    <>
    <BrowserView>
    <Card >
      <CardMedia
        component="img"
        height="85"
        image={LogoDelivery}
        alt="NAFIL Delivery"
      />
      <CardContent>
        <Typography style={{ color:"#000", fontSize:'16px', fontWeight:'bold' }}>
          { (_cidade.map(a => a.cidade).length > 0 ? _cidadeClicada : 'Clique na Cidade ao Lado...' ) }
        </Typography>
        <Typography gutterBottom component="div" color={"red"} fontSize="15px">
          Cidade Atendida Pela Filial NAFIL 
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <Grid container xs={12}>
            <Grid item container xs={3} alignContent='right' alignItems='right' justify='flex-end'>Endereço:</Grid>
            <Grid item container xs={9} alignContent='left' alignItems='left' justify='flex-start' style={{ color:"#000", fontSize:'13px', fontWeight:'bold', marginTop:'1px', marginLeft:"0", textAlign:"left" }}>{ (_cidade.map(a => a.cidade).length > 0 ? _recebido[0].map(a => a.rua) + ", " + _recebido[0].map(a => a.numero) : '' ) }</Grid>          </Grid>
          <Grid container xs={12}>
            <Grid item container xs={3} alignContent='right' alignItems='right' justify='flex-end'>Bairro:</Grid>
            <Grid item container xs={9} alignContent='left' alignItems='left' justify='flex-start' style={{ color:"#000", fontSize:'13px', fontWeight:'bold', marginTop:'1px' }}>{_recebido[0].map(a => a.bairro)}</Grid>
          </Grid>
          <Grid container xs={12}>
            <Grid item container xs={3} alignContent='right' alignItems='right' justify='flex-end'>Cidade - UF:</Grid>
            <Grid item container xs={9} alignContent='left' alignItems='left' justify='flex-start' style={{ color:"#000", fontSize:'13px', fontWeight:'bold', marginTop:'1px' }}>{ (_cidade.map(a => a.cidade).length > 0 ? _recebido[0].map(a => a.cidade) + " - " + _recebido[0].map(a => a.sigla) : '' )}</Grid>
          </Grid>
          <Grid container xs={12}>
            <Grid item container xs={3} alignContent='right' alignItems='right' justify='flex-end' style={{ marginTop:"5px" }}>Telefone:</Grid>
            <Grid item container xs={9} alignContent='left' alignItems='left' justify='flex-start' style={{ color:"#000", fontSize:'20px', fontWeight:'bold', marginTop:'-1px' }}>{ formatarTelefone(_telefone??"") }</Grid>
          </Grid>
          <Grid container xs={12} >
            <Grid item container flexWrap xs={12} alignContent='left' alignItems='left' justify='flex-start' display={"inline-block"} style={{ marginTop:"5px" }}>
              <Typography style={{display: 'flex'}} fontSize={13}>Entregas:</Typography>
              <Typography style={{display: 'flex'}} fontSize={13}>{ _horarioSemanal  }</Typography>
              <Typography style={{display: 'flex'}} fontSize={13}>{  _horarioFinalSemana }</Typography>
            </Grid>            
          </Grid>
 
        </Typography>
      </CardContent>
    </Card>
    </BrowserView>

    <MobileView>
    <Card>
      <CardMedia
        component="img"
        height="75"
        image={LogoDelivery}
        alt="NAFIL Delivery"        
      />
      <CardContent>
        <Typography style={{ color:"#000", fontSize:'16px', fontWeight:'bold' }}>
          { (_cidade.map(a => a.cidade).length > 0 ? _cidadeClicada : 'Clique na Cidade Abaixo...' ) }
        </Typography>
        <Typography gutterBottom component="div" color={"red"} fontSize="15px">
          Cidade Atendida Pela Filial NAFIL 
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <Grid container xs={12}>
            <Grid item container xs={3} alignContent='right' alignItems='right' justify='flex-end'>Endereço:</Grid>
            <Grid item container xs={9} alignContent='left' alignItems='left' justify='flex-start' style={{ color:"#000", fontSize:'13px', fontWeight:'bold', marginTop:'1px', marginLeft:"0", textAlign:"left" }}>{ (_cidade.map(a => a.cidade).length > 0 ? _recebido[0].map(a => a.rua) + ", " + _recebido[0].map(a => a.numero) : '' ) }</Grid>          </Grid>
          <Grid container xs={12}>
            <Grid item container xs={3} alignContent='right' alignItems='right' justify='flex-end'>Bairro:</Grid>
            <Grid item container xs={9} alignContent='left' alignItems='left' justify='flex-start' style={{ color:"#000", fontSize:'13px', fontWeight:'bold', marginTop:'1px' }}>{_recebido[0].map(a => a.bairro)}</Grid>
          </Grid>
          <Grid container xs={12}>
            <Grid item container xs={3} alignContent='right' alignItems='right' justify='flex-end'>Cidade - UF:</Grid>
            <Grid item container xs={9} alignContent='left' alignItems='left' justify='flex-start' style={{ color:"#000", fontSize:'13px', fontWeight:'bold', marginTop:'1px' }}>{ (_cidade.map(a => a.cidade).length > 0 ? _recebido[0].map(a => a.cidade) + " - " + _recebido[0].map(a => a.sigla) : '' )}</Grid>
          </Grid>
          <Grid container xs={12}>
            <Grid item container xs={3} alignContent='right' alignItems='right' justify='flex-end' style={{ marginTop:"5px" }}>Telefone:</Grid>
            <Grid item container xs={9} alignContent='left' alignItems='left' justify='flex-start' style={{ color:"#000", fontSize:'20px', fontWeight:'bold', marginTop:'-1px' }}>{ formatarTelefone(_telefone??"") }</Grid>
          </Grid>
          <Grid container xs={12} >
            <Grid item container flexWrap xs={12} alignContent='left' alignItems='left' justify='flex-start' display={"inline-block"} style={{ marginTop:"5px" }}>
              <Typography style={{display: 'flex'}} fontSize={13}>Entregas:</Typography>
              <Typography style={{display: 'flex'}} fontSize={13}>{ _horarioSemanal  }</Typography>
              <Typography style={{display: 'flex'}} fontSize={13}>{  _horarioFinalSemana }</Typography>
            </Grid>            
          </Grid>
 
        </Typography>
      </CardContent>
    </Card>
    </MobileView>

    </>
  );
}